import React, {Component} from 'react';
import {getTranslations, showPriceWithCurrency} from "@assets/js/functions/helpers";

const translations = getTranslations();

export default class ApartmentPrice extends Component {
    render() {
        const {apartment: {price_total, price_single, total_days_string}} = this.props

        const singlePrice = showPriceWithCurrency(price_single);
        const totalPrice = showPriceWithCurrency(price_total);

        return (
            <div className="apartment-book-price">
                {price_total === null ? (
                    <div className="apartment-book-price__row">
                        <span>{translations['from']} </span>
                        <span className="apartment-book-price-value">{singlePrice.price} </span>
                        <span className="apartment-book-price-currency">{singlePrice.currency} </span>
                        <span>{'| ' + translations['full-day']}</span>
                    </div>
                ) : (
                    <div className="apartment-book-price__row">
                        <span className="apartment-book-price-value">{totalPrice.price} </span>
                        <span className="apartment-book-price-currency">{totalPrice.currency} </span>
                        <span>{'| ' + total_days_string}</span>
                    </div>
                )}
            </div>
        )
    }
}

